import { connect } from 'react-redux';
import PengisianPraktek from '../../../views/Kurikulum/Ulangan/PengisianPraktek.view';
import { getStudent } from '../../../states/thunks/student.thunk';


function mapDispatchToProps(dispatch) {
  return {
    handleGetStudent: () => dispatch(getStudent()),
  };
}
export default connect(null, mapDispatchToProps)(PengisianPraktek);
